import { gql } from '@apollo/client'

export const GET_EMPLOYEE_RENTALS = gql`
  query getEmployeeRentals(
    $id: ID!
    $employeeId: ID!
    $first: Int!
    $after: Int!
  ) {
    employee(id: $employeeId, organisationId: $id) {
      rentals(pagination: { after: $after, first: $first }) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        rentals {
          id
          stocklistItem {
            id
            imei
            imei2
            serialNumber
            eid
          }
          deviceDefinition {
            id
            name
            imageURL
            productType
          }
        }
      }
    }
  }
`
